<script>
  import CodeSnippet from '../components/CodeSnippet.svelte';

  const snippet = `
    <!-- Heading -->

    <h1 class="heading heading-1">Heading 1</h1>
    <h2 class="heading heading-2">Heading 2</h2>
    <h3 class="heading heading-3">Heading 3</h3>
    <h4 class="heading heading-4">Heading 4</h4>
    <h5 class="heading heading-5">Heading 5</h5>
    <h6 class="heading heading-6">Heading 6</h6>

    <!-- Copy -->
    
    <p class="copy">Normal copy</p>
    <p class="copy copy-large">Large copy</p>
    <p class="copy copy-small">Small copy</p>
  `;
</script>

<template>
  <section id="typography" class="page-section bg-sunsetPink40">
    <div class="container">
      <h2 class="heading heading-2 my-6">Typography</h2>

      <div class="space-y-4 my-8">
        <h1 class="heading heading-1">Heading 1</h1>
        <h2 class="heading heading-2">Heading 2</h2>
        <h3 class="heading heading-3">Heading 3</h3>
        <h4 class="heading heading-4">Heading 4</h4>
        <h5 class="heading heading-5">Heading 5</h5>
        <h6 class="heading heading-6">Heading 6</h6>
      </div>

      <div class="space-y-4">
        <p class="copy copy-large">
          <strong>Large copy</strong>
          : Phasellus at aliquet mi. Nulla venenatis elementum congue. Ut tincidunt orci nisl, ut convallis nibh egestas quis. Orci varius natoque penatibus et magnis dis parturient montes, nascetur
          ridiculus mus. Phasellus vitae mi ac velit semper pharetra. Nullam facilisis ac diam nec vulputate. Praesent ornare id ex porttitor luctus. Mauris at metus tortor. Nulla a purus ac risus
          gravida congue porta bibendum ante. Sed leo elit, cursus eget malesuada ut, fermentum nec quam. Aliquam facilisis pharetra est eu porta. Quisque tincidunt erat ut leo pulvinar, sed auctor
          justo dapibus.
        </p>
        <p class="copy">
          <strong>Normal copy</strong>
          : Ut tincidunt orci nisl, ut convallis nibh egestas quis. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Phasellus vitae mi ac velit semper pharetra.
          Nullam facilisis ac diam nec vulputate. Praesent ornare id ex porttitor luctus. Mauris at metus tortor. Nulla a purus ac risus gravida congue porta bibendum ante. Sed leo elit, cursus eget
          malesuada ut, fermentum nec quam. Aliquam facilisis pharetra est eu porta. Quisque tincidunt erat ut leo pulvinar, sed auctor justo dapibus.
        </p>
        <p class="copy copy-small">
          <strong>Small copy</strong>
          : Ut tincidunt orci nisl, ut convallis nibh egestas quis. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Phasellus vitae mi ac velit semper pharetra.
          Nullam facilisis ac diam nec vulputate. Praesent ornare id ex porttitor luctus. Mauris at metus tortor. Nulla a purus ac risus gravida congue porta bibendum ante. Sed leo elit, cursus eget
          malesuada ut, fermentum nec quam. Aliquam facilisis pharetra est eu porta. Quisque tincidunt erat ut leo pulvinar, sed auctor justo dapibus.
        </p>
        <CodeSnippet id="typography" {snippet} />
      </div>
    </div>
  </section>
</template>
